export const Logo = require('./Logo.png');